// extracted by mini-css-extract-plugin
module.exports = {"card":"PeriodList_card__fhoEs","img":"PeriodList_img__3_6rD"};